import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import Loading from '../layout/Loading';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useContext(AuthContext);

  if (loading) {
    return <Loading message="Checking admin access..." />;
  }

  return isAuthenticated && user && user.role === 'admin' ? 
    children : 
    <Navigate to="/dashboard" />;
};

export default AdminRoute;
